export default __webpack_public_path__ + "static/jiahui-58e9c7c04018aa5bff16bc66352bb8fc.png";